
export function getArtworkURL(item, width, height) {
    const artwork = item?.attributes?.artwork ?? item?.container?.attributes?.artwork;
    if (!artwork) {
        return undefined;
    } else if (/\{(?:w|h)\}/.test(artwork.url)) {
        return MusicKit.formatArtworkURL(artwork, width, height);
    } else {
        return artwork.url;
    }
}

export async function fetchPaginated(url, queryParams) {
    const music = MusicKit.getInstance();
    const items = [];

    while (true) {
        const { data: { data, meta: { total } = { total: 0 } } } = await music.api.music(url, {
            ...queryParams,
            offset: items.length,
        });
        items.push(...data);
        if (data.length == 0 || items.length >= total) {
            break;
        }
    }

    return items;
}

export async function fetchMediaItems(type, id) {
    const music = MusicKit.getInstance();
    switch (type) {
        case "albums": {
            const tracks = await fetchPaginated(`/v1/catalog/{{storefrontId}}/albums/${id}/tracks`);
            return tracks.map(item => ({ ...item, _container: item }));
        };
        case "library-albums": {
            const tracks = await fetchPaginated(`/v1/me/library/albums/${id}/tracks`);
            return tracks.map(item => ({ ...item, _container: item }));
        };
        case "playlists": {
            const tracks = await fetchPaginated(`/v1/catalog/{{storefrontId}}/playlists/${id}/tracks`);
            return tracks.map(item => ({ ...item, _container: item }));
        };
        case "library-playlists": {
            const tracks = await fetchPaginated(`/v1/me/library/playlists/${id}/tracks`);
            return tracks.map(item => ({ ...item, _container: item }));
        };
        case "songs": {
            const { data: { data: [song] } } = await music.api.music(`/v1/catalog/{{storefrontId}}/songs/${id}`);
            return [{ ...song, _container: song }];
        };
        case "library-songs": {
            const { data: { data: [song] } } = await music.api.music(`/v1/me/library/songs/${id}`);
            return [{ ...song, _container: song }];
        };
    }
}

export function invertColor(hex, bw) {
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }

    // convert 3-digit hex to 6-digit hex (eg. `#333` to `#333333`).
    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    if (hex.length !== 6) {
        throw new Error("invalid hex color");
    }

    let r = parseInt(hex.slice(0, 2), 16);
    let g = parseInt(hex.slice(2, 4), 16);
    let b = parseInt(hex.slice(4, 6), 16);

    if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return ((r * 0.299 + g * 0.587 + b * 0.114) > 130)
            ? "#171717"
            : "#E0E0E0";
    }

    // invert color components, and pad with zeros
    r = (255 - r).toString(16).padStart(2, "0");
    g = (255 - g).toString(16).padStart(2, "0");
    b = (255 - b).toString(16).padStart(2, "0");

    return `#${r}${g}${b}`;
}

export async function determineCatalogAlbumId(album) {
    const music = MusicKit.getInstance();

    const found = album.relationships.tracks.data
        .find(song => song.attributes && song.attributes.playParams && song.attributes.playParams.catalogId);

    if (found === undefined) {
        return undefined;
    }

    const songId = found.attributes.playParams.catalogId;
    const { data: { data: [song] } } = await music.api.music(`/v1/catalog/{{storefrontId}}/songs/${songId}`);

    for (const albumData of song.relationships.albums.data) {
        const { data: { data: [catalogAlbum] } } = await music.api.music(`/v1/catalog/{{storefrontId}}/albums/${albumData.id}`);
        if (
            catalogAlbum.attributes.artistName === album.attributes.artistName &&
            catalogAlbum.attributes.albumName === album.attributes.albumName
        ) {
            return catalogAlbum;
        }
    }

    return undefined;
}
